import styled from 'styled-components';

export const Container = styled.div<{ $collapsed: boolean }>`
  text-align: center;

  ${({ $collapsed }) =>
    $collapsed &&
    `overflow: hidden;
    text-overflow: ellipsis;
    white-space: initial;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;

    * {
      // line-clamp Firefox/Safari support for a parent with multiple nested block elements
      display: contents;
    }

    *:after {
      white-space:pre;
    }
  `}
`;
